class h extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M7 14H2a1.001 1.001 0 0 1-1-1V1h1v12h5v1Zm8-2.5v-1h-1.045a2.98 2.98 0 0 0-.512-1.235l.739-.74-.707-.707-.74.74a2.98 2.98 0 0 0-1.235-.513V7h-1v1.045a2.98 2.98 0 0 0-1.235.512l-.74-.739-.707.707.74.74c-.263.367-.438.79-.513 1.235H7v1h1.045c.075.445.25.868.512 1.235l-.739.74.707.707.74-.74c.367.263.79.438 1.235.513V15h1v-1.045c.445-.075.868-.25 1.235-.512l.74.739.707-.707-.74-.74c.263-.367.438-.79.513-1.235H15ZM11 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm3-7V2h-4v4h1V3h2v3h1Z"></path><path d="M8 7V5H4v7h1.938v-1H5V6h2v1h1Z"></path></svg>';
  }
}
const t = "pi-chart-settings";
customElements.get(t) || customElements.define(t, h);
export {
  h as default
};
